<template>
    <div class="side-left" :class="show?'to-open-right':'to-hide-left'">
        <div class="wrap-thumbnail scrollable">
            <div class="list-thumbnail">
                <div class="thumbnail">
                    <!--<img src="/images/openimagehealth/example/thumb1.png" />-->
                    <div class="loading">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                    </div>
                </div>
                <div class="description py-1 px-2">
                    <span class="c-white">2.0</span>
                    <div class="d-flex justify-content-between">
                            <span>
                                s: 1
                            </span>
                        <span>
                                I: 1
                            </span>
                        <span>
                                <span class="i-square"></span>
                                2
                            </span>
                    </div>
                </div>
            </div>
            <div class="list-thumbnail">
                <div class="thumbnail">
                    <img src="/images/openimagehealth/example/thumb2.png" />
                </div>
                <div class="description py-1 px-2">
                    <span class="c-white">Body 3.0 CE</span>
                    <div class="d-flex justify-content-between">
                            <span>
                                s: 2
                            </span>
                        <span>
                                I: 1
                            </span>
                        <span>
                                <span class="i-square"></span>
                                120
                            </span>
                    </div>
                </div>
            </div>
            <div class="list-thumbnail">
                <div class="thumbnail">
                    <img src="/images/openimagehealth/example/thumb3.png" />
                </div>
                <div class="description py-1 px-2">
                    <span class="c-white">Lung 3.0 CE</span>
                    <div class="d-flex justify-content-between">
                            <span>
                                s: 3
                            </span>
                        <span>
                                I: 1
                            </span>
                        <span>
                                <span class="i-square"></span>
                                117
                            </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: ['show']
    }
</script>